<main class="auth-container">
  <div class="floating-icons" aria-hidden="true">
    <img
      *ngFor="let icon of randomIcons"
      [src]="icon.src"
      [ngStyle]="{
        position: 'absolute',
        top: icon.top,
        left: icon.left,
        transform: 'rotate(' + icon.rotate + 'deg) scale(' + icon.scale + ')',
        width: '40px',
        opacity: '0.28',
        transition: 'all 0.5s ease'
      }"
    />
  </div>
  <section class="auth-shell container">
    <app-login-component homeLink="/"></app-login-component>
  </section>
</main>
